import { useSelector, useDispatch } from "react-redux"
import { useContext, useCallback } from "react"
import { createThread as createThreadAction } from "../features/messageThreads/createThread"
import { viewContext } from "../context/viewContext"

export const useCreateThread = () => {
  const { unique_owner_id } = useContext(viewContext)
  const dispatch = useDispatch()
  const owner = useSelector(state => state.owners[unique_owner_id])

  const status = owner?.actionStatuses?.createThread?.status
  const loaded = owner?.actionStatuses?.createThread?.loaded

  const isFetching = status === 'fetching'
  const isLoading = status === 'fetching' && !loaded
  const isSuccess = status === 'success'
  const error = status === 'failed'

  const createThread = useCallback(async (message) => {
    try {
      const response = await dispatch(createThreadAction(message))
      return response
    } catch (error) {
      throw error
    }
  }, [dispatch])

  return [
    createThread,
    {
      isFetching,
      isLoading,
      isSuccess,
      error,
    }
  ]
}
